import { Button, Typography } from '@breetometer/components';
import { FiatIcon } from 'BreetAssets';
import { TransactionDetails } from 'BreetComponents';

import type { IFiatTransactionDetailsViewProps } from './FiatTransactionDetails.helpers';

const FiatTransactionDetailsView = ({
	amount,
	expectedFiat,
	handleVerification,
	symbol,
	balance,
	isLoading,
	rate,
}: IFiatTransactionDetailsViewProps) => (
	<div className='transaction-details payment-request-form_usdDestination'>
		<TransactionDetails.Content>
			<TransactionDetails.Row
				label='Amount to Withdraw:'
				value={`${symbol}${amount}`}
			/>

			<TransactionDetails.Row
				label='Current Rate:'
				value={rate}
			/>

			<TransactionDetails.Row
				label={`Expected ${expectedFiat.currencyCode} Equivalent:`}
				value={expectedFiat.amount}
			/>
		</TransactionDetails.Content>

		<div className='transaction-details_balance bg-primary-400 border-dark-navy'>
			<FiatIcon
				currencyCode={balance.currencyCode}
				variant='round'
			/>
			<Typography className='color-neutral-50'>
				{balance.currencyCode} Balance - <span>{balance.amount}</span>
			</Typography>
		</div>

		<Button
			label='Withdraw'
			className='right-sheet_cta_fullwidth'
			type='button'
			onClick={handleVerification}
			isLoading={isLoading}
		/>
	</div>
);

export default FiatTransactionDetailsView;
